import posTokenToLocalStorage from './1-pos-token-to-local-storage';

const jobs = [
  posTokenToLocalStorage()
  // Next job comes here.
];

export default jobs;
